import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

type AssetListPerformanceProps = {
  identifiers: string[];
  symbolLinkClick?: (event: any) => void;
};

export function AssetListPerformance({
  identifiers,
  symbolLinkClick,
}: AssetListPerformanceProps) {
  const config = [
    { type: "attribute", key: "identifiers", value: identifiers },
  ] as ConfigItem[];

  if (symbolLinkClick) {
    config.push({ type: "event", key: "row-click", value: symbolLinkClick });
  }

  return <FactSetWidget config={config} widget="asset-list-performance" />;
}
